import { render, staticRenderFns } from "./show.logs.page.vue?vue&type=template&id=4c540ca7&scoped=true&"
import script from "./show.logs.page.vue?vue&type=script&lang=js&"
export * from "./show.logs.page.vue?vue&type=script&lang=js&"
import style0 from "./show.logs.page.vue?vue&type=style&index=0&id=4c540ca7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c540ca7",
  null
  
)

export default component.exports